import { useQueryClient } from '@tanstack/react-query';
import { useMutation } from 'query';
import { handleAxiosError } from 'common/error-handlers';
import { getEventsQueryKey } from '../';
import { type UserRSVP } from '../../../events/types';
import { updateEventUserStatus } from '../../services';

export const useUpdateEventUserStatus = () => {
  const queryClient = useQueryClient();
  return useMutation<undefined, { id: string; statusToApply: UserRSVP }>(
    async ({ id, statusToApply }) => {
      const response = await updateEventUserStatus(id, statusToApply);

      return response.data;
    },
    {
      async onSuccess() {
        // TODO this is somehow how we can find existing data and modify them after
        // we need to change it for performance
        // const data = queryClient.getQueriesData<InfiniteData<ListEvent[]>>({
        //   queryKey: getEventsQueryKey({ 'upcoming' }),
        //   exact: false
        // });

        await queryClient.invalidateQueries(getEventsQueryKey({ type: 'upcoming' }));
      },
      async onError(error) {
        handleAxiosError(error);
        await queryClient.invalidateQueries(getEventsQueryKey({}));
      },
    },
  );
};
